import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deviceData-discreteRate",
  "use": "deviceData-discreteRate-usage",
  "viewBox": "0 0 16 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 8\" id=\"deviceData-discreteRate\">\n<style type=\"text/css\">\n\t#deviceData-discreteRate .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<g id=\"deviceData-discreteRate_web\">\n\t<g id=\"deviceData-discreteRate_切图\" transform=\"translate(-32.000000, -97.000000)\">\n\t\t<path id=\"deviceData-discreteRate_形状结合\" class=\"st0\" d=\"M36.5,102.6c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7h-1.8c-0.4,0-0.7-0.3-0.7-0.7\n\t\t\ts0.3-0.7,0.7-0.7H36.5z M40.9,102.6c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7h-1.8c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7H40.9z\n\t\t\t M45.2,102.6c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7h-1.8c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7H45.2z M45.2,99\n\t\t\tc0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7H34.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7H45.2z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/deviceData-discreteRate.svg
// module id = a8aX
// module chunks = 268